import { render } from "./GoodsDetails.vue?vue&type=template&id=12229fa7"
import script from "./GoodsDetails.vue?vue&type=script&lang=js"
export * from "./GoodsDetails.vue?vue&type=script&lang=js"

import "./GoodsDetails.vue?vue&type=style&index=0&id=12229fa7&lang=less"

import exportComponent from "/Users/longliu/Desktop/projects/povertyalleviation/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__